import React from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';

import BackgroundImage from '@/components/BackgroundImage';
import Button from '@/components/Button';
import getDestinationRoute from '@/utils/getDestinationRoute';
import map from './assets/map.png';

const OuterBox = styled(Box)`
  cursor: pointer;
`;

const shallowPushMapView = (router) => () => {
  const { asPath, query } = router;
  const { destinationName } = query;

  router
    .push(
      {
        pathname: `/${getDestinationRoute(destinationName)}/map`,
        search: asPath.split('?')[1],
      },
      undefined,
      { shallow: true },
    )
    .then(() => window.scroll(0, 0));
};

const MapViewButton = React.memo(() => {
  const router = useRouter();

  return (
    <OuterBox
      data-testid="MAP_VIEW_BUTTON"
      onClick={shallowPushMapView(router)}
    >
      <BackgroundImage
        py="6"
        width={[null, null, '400px']}
        src={map}
        role="img"
      >
        <Flex justifyContent="center" alignItems="center">
          <Button variant="secondary" dialogue>
            Show map
          </Button>
        </Flex>
      </BackgroundImage>
    </OuterBox>
  );
});

export default MapViewButton;
